"use strict";
/**
 * @file Created on Thu Dec 12 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var utils_1 = require("../../core/utils");

var DummyWindowSimulationSession_1 = require("../model/DummyWindowSimulationSession");

var DummyWindowSimulationParamsConverter_1 = require("./DummyWindowSimulationParamsConverter");

var DummyWindowSimulationSessionConverter_1 = require("./DummyWindowSimulationSessionConverter");

var WindowConverter_1 = require("./WindowConverter");

var WindowItemConverter_1 = require("./WindowItemConverter");
/**
 * @author Tomas Leity
 */


var DummyWindowSimulationSessionConverterImpl =
/*#__PURE__*/
function (_DummyWindowSimulatio) {
  _inherits(DummyWindowSimulationSessionConverterImpl, _DummyWindowSimulatio);

  /**
   * @param paramsConverter
   * @param windowConverter
   * @param windowItemConverter
   */
  function DummyWindowSimulationSessionConverterImpl(paramsConverter, windowConverter, windowItemConverter) {
    var _this;

    _classCallCheck(this, DummyWindowSimulationSessionConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DummyWindowSimulationSessionConverterImpl).call(this));
    _this.paramsConverter = paramsConverter;
    _this.windowConverter = windowConverter;
    _this.windowItemConverter = windowItemConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(DummyWindowSimulationSessionConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new DummyWindowSimulationSession_1.DummyWindowSimulationSession(DummyWindowSimulationSession_1.DummyWindowSimulationSession.schema.id.valueOf(conversions.documentToClassId(source)), this.paramsConverter.toObject(source.params, conversions), this.windowConverter.toObject(source.window, conversions), this.windowItemConverter.toObject(source.windowItem, conversions));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        params: this.paramsConverter.toDocument(source.params, conversions),
        window: this.windowConverter.toDocument(source.window, conversions),
        windowItem: this.windowItemConverter.toDocument(source.windowItem, conversions)
      });
      return result;
    }
    /**
     * Deserialize Window document
     * @param conversions
     */

  }, {
    key: "deserializeWindow",
    value: function deserializeWindow(conversions) {
      var _this2 = this;

      return function (document) {
        return utils_1.Utils.isValueMissing(document) ? null : _this2.windowConverter.toObject(document, conversions);
      };
    }
    /**
     * Serialize Window object
     * @param conversions
     */

  }, {
    key: "serializeWindow",
    value: function serializeWindow(conversions) {
      var _this3 = this;

      return function (object) {
        return utils_1.Utils.isValueMissing(object) ? null : _this3.windowConverter.toDocument(object, conversions);
      };
    }
    /**
     * Deserialize WindowItem document
     * @param conversions
     */

  }, {
    key: "deserializeWindowItem",
    value: function deserializeWindowItem(conversions) {
      var _this4 = this;

      return function (document) {
        return utils_1.Utils.isValueMissing(document) ? null : _this4.windowItemConverter.toObject(document, conversions);
      };
    }
    /**
     * Serialize WindowItem object
     * @param conversions
     */

  }, {
    key: "serializeWindowItem",
    value: function serializeWindowItem(conversions) {
      var _this5 = this;

      return function (object) {
        return utils_1.Utils.isValueMissing(object) ? null : _this5.windowItemConverter.toDocument(object, conversions);
      };
    }
  }]);

  return DummyWindowSimulationSessionConverterImpl;
}(DummyWindowSimulationSessionConverter_1.DummyWindowSimulationSessionConverter);

DummyWindowSimulationSessionConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __metadata("design:paramtypes", [DummyWindowSimulationParamsConverter_1.DummyWindowSimulationParamsConverter, WindowConverter_1.WindowConverter, WindowItemConverter_1.WindowItemConverter])], DummyWindowSimulationSessionConverterImpl);
exports.DummyWindowSimulationSessionConverterImpl = DummyWindowSimulationSessionConverterImpl;